<template>
  <div class="contract-inventory-picking">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button
            v-if="funcView.contract_inventory_picking_add"
            type="primary"
            icon="el-icon-plus"
            @click="addOrder"
          >{{ funcView.contract_inventory_picking_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('crm_inventory_picking_manage.kcfckftbdh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['detail', 'action']"
      >
        <template v-slot:detail="scope">
          <div>
            <el-tooltip
              placement="top"
              v-if="scope.row.goodsList && scope.row.goodsList.length"
            >
              <div slot="content">
                <table style="width:300px; line-height: 30px;">
                  <thead>
                    <th>{{ $t('crm_inventory_picking_manage.xing_hao') }}</th>
                    <th>{{ $t('crm_inventory_picking_manage.chan_pinSN') }}</th>
                    <th>{{ $t('crm_inventory_picking_manage.shu_liang') }}</th>
                    <th>{{ $t('crm_inventory_picking_manage.she_bei_lei_xing') }}</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in scope.row.goodsList"
                      :key="index"
                    >
                      <td style="text-align:center;">{{ item.productCode }}</td>
                      <td style="text-align:center;">{{ item.productSns }}</td>
                      <td style="text-align:center;">{{ item.bookingNum }}</td>
                      <td style="text-align:center;">{{ getDicValue('dms_device_biz_type', item.deviceBizType) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <el-button
                type="text"
                size="mini"
              >{{
                $t('crm_inventory_picking_manage.she_bei_xiang_qing')
              }}</el-button>
            </el-tooltip>
          </div>
        </template>
        <template v-slot:action="scope">
          <span></span>
          <!-- 编辑 -->
          <el-button
            v-if="
                funcView.contract_inventory_picking_edit &&
                  checkRole(scope.row.orderState, FUNC_TYPES.EDIT)
              "
            type="text"
            size="mini"
            @click="editOrder(scope.row)"
          >{{ funcView.contract_inventory_picking_edit }}</el-button>
          <!-- 删除 -->
          <el-button
            v-if="
                funcView.contract_inventory_picking_del &&
                  checkRole(scope.row.orderState, FUNC_TYPES.DEL)
              "
            type="text"
            size="mini"
            @click="onDel(scope.row)"
          >{{ funcView.contract_inventory_picking_del }}</el-button>
          <!-- 提交 -->
          <el-button
            @click="onSubmit(scope.row)"
            v-if="
                funcView.contract_inventory_picking_submit &&
                  checkRole(scope.row.orderState, FUNC_TYPES.SUBMIT)
              "
            type="text"
            size="mini"
            :disabled="!workFlowType"
          >{{ funcView.contract_inventory_picking_submit }}</el-button>
          <!-- 详情 -->
          <el-button
            @click="onPreview(scope.row)"
            v-if="
                funcView.contract_inventory_picking_detail &&
                  checkRole(scope.row.orderState, FUNC_TYPES.DETAIL)
              "
            type="text"
            size="mini"
          >{{ funcView.contract_inventory_picking_detail }}</el-button>
          <!-- 审批 -->
          <!-- 判断审批有3个条件： -->
          <!-- 1:后台配置的funcView -->
          <!-- 2:工单状态为审批中，即checkRole -->
          <!-- 3：调用接口判断用户是有对该工单有审批的资格 approvalAuth -->
          <!-- <el-button
            v-if="
                funcView.contract_inventory_picking_approval &&
                  checkRole(scope.row.orderState, FUNC_TYPES.APPROVAL) && scope.row.approvalAuth.includes('APPROVE')
              "
            type="text"
            size="mini"
            @click="onApproval(scope.row)"
          >{{ funcView.contract_inventory_picking_approval }}</el-button> -->
          <!-- 撤销 -->
          <el-button
            v-if="
                funcView.contract_inventory_picking_cancel &&
                  checkRole(scope.row.orderState, FUNC_TYPES.CANCEL)
              "
            @click="onCancel(scope.row)"
            type="text"
            size="mini"
          >{{ funcView.contract_inventory_picking_cancel }}</el-button>
          <!-- 作废 -->
          <el-button
            v-if="
                funcView.contract_inventory_picking_nullify &&
                  checkRole(scope.row.orderState, FUNC_TYPES.NULLIFY)
              "
            @click="onNullify(scope.row)"
            type="text"
            size="mini"
          >{{ funcView.contract_inventory_picking_nullify }}</el-button>
          <!-- 发货 -->
          <el-button
            v-if="funcView.contract_inventory_picking_deliver_goods && scope.row.waitDeliver > 0 && checkDeliverGoods(scope.row) && checkRole(scope.row.orderState, FUNC_TYPES.DELIVER_GOODS)"
            type="text"
            size="mini"
            @click="onDeliver(scope.row)"
          >{{
                funcView.contract_inventory_picking_deliver_goods
              }}</el-button>
          <!-- 下载调拨单 -->
          <el-button
            v-if="
                funcView.contract_inventory_picking_download &&
                  checkRole(scope.row.orderState, FUNC_TYPES.DOWNLOAD)
              "
            type="text"
            size="mini"
            @click="onDownload(scope.row)"
          >{{ funcView.contract_inventory_picking_download }}</el-button>
          <!-- 修改项目负责人 -->
          <el-button
            v-if="
                funcView.contract_inventory_picking_modify_project_leader &&
                  checkRole(
                    scope.row.orderState,
                    FUNC_TYPES.MODIFY_PROJECT_LEADER
                  )
              "
            type="text"
            size="mini"
            @click="onModifyProjectLeader"
          >{{
                funcView.contract_inventory_picking_modify_project_leader
              }}</el-button>
          <!-- 服务收货 -->
          <el-button
            v-if="funcView.contract_inventory_picking_service_receiving && checkReceiving(scope.row) && checkRole(scope.row.orderState, FUNC_TYPES.SERVICE_RECEIVING)"
            type="text"
            size="mini"
            @click="receiveGoods(scope.row)"
          >{{
                funcView.contract_inventory_picking_service_receiving
              }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <approval-dialog
      v-if="dialog1Visible"
      :model="dialog1Model"
      @close="dialog1Visible = false"
      @success="getTableList"
    ></approval-dialog>
    <modify-project-leader-dialog
      v-if="dialog2Visible"
      :model="dialog2Model"
      @close="dialog2Visible = false"
    ></modify-project-leader-dialog>
    <receiving-dialog
      v-if="dialog3Visible"
      :model="dialog3Model"
      @close="dialog3Visible = false"
    ></receiving-dialog>
    <deliver-goods-dialog
      v-if="dialog4Visible"
      :model="dialog4Model"
      @close="dialog4Visible = false"
      @success="onPageChange({page: 1})"
    ></deliver-goods-dialog>
    <!-- 库存调拨申请单 -->
    <stock-approval-dialog
      v-if="dialog6Visible"
      @close="dialog6Visible = false"
      @success="getTableList"
      :model="dialog6Model"
    ></stock-approval-dialog>

    <!-- 售后公司收货 -->
    <receive-goods-dialog
      v-if="dialog7Visible"
      @close="dialog7Visible = false"
      :model="dialog7Model"
      @success="getTableList"
    ></receive-goods-dialog>
  </div>
</template>

<script>
/** 库存调拨 */
import apis from '@/utils/apis';
import stockApprovalDialog from '@/components/approvalCenter/approval_dialog.vue';

import approvalDialog from '@/pages/crm/contract/children/contract_approval_dialog';
import deliverGoodsDialog from '@/pages/crm/contract/children/deliver_goods_dialog';
import modifyProjectLeaderDialog from '@/pages/crm/contract/children/contract_modify_project_leader_dialog';
import receivingDialog from '@/pages/crm/contract/children/service_company_receiving_dialog';

// import orderDownload from '@/pages/crm/contract/children/inventory_transfer_order_download';

import receiveGoodsDialog from '@/pages/crm/contract/children/receive_goods_dialog';
import mixins from '../mixins';

// 统一审批接口type
const type = 'transfer_order';


export default {
  mixins: [mixins],
  name: 'contractInventoryPicking',
  components: {
    approvalDialog,
    modifyProjectLeaderDialog,
    receivingDialog,
    deliverGoodsDialog,

    stockApprovalDialog,
    receiveGoodsDialog,
  },
  computed: {
    workFlowType() {
      return type;
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  data() {
    return {
      tableCode: 'contract_inventory_picking',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: 0,
      tableList: [],
      dialog1Model: {},
      dialog1Visible: false,
      dialog2Model: {},
      dialog2Visible: false,
      // 售后公司收货
      dialog3Model: {},
      dialog3Visible: false,
      // 发货
      dialog4Model: {},
      dialog4Visible: false,
      // 库存调拨单
      dialog5Model: {},
      dialog5Visible: false,

      // 库存调拨申请单
      dialog6Model: {},
      dialog6Visible: false,
      // 售后公司收货
      dialog7Visible: false,
      dialog7Model: {},
    };
  },
  methods: {
    // 判断是否有发货权限
    checkDeliverGoods(row) {
      if (this.userInfo) {
        /**
         * 组织类型：bas_org_type
           PF 平台  platform
           HQ 总部  factory
           SC 售后公司  service
           JV 代理公司  agent
           JV_SC 服务公司  agent_service
           CO 大客户  large_customer
           CS 租赁方  customer

           调拨单状态：crm_transfer_order_state
           1 草稿 draft
           6 审批中 ing
           10 审批通过 pass
           20 待发货 wait_ship
           21 在途中 on_the_way
           22 已收货 received
           80 已完成 finished
           90 审批拒绝 refuse
           100 已作废 abolished
         */
        if (row.outOrgId === this.userInfo.rootOrgId) {
          // 总部或者售后公司的状态为已完成的，应不显示发货操作
          if (this.userInfo && this.dicMap.bas_org_type && this.dicMap.crm_transfer_order_state) {
            const arr = [
              `${this.dicMap.bas_org_type.factory}`,
              `${this.dicMap.bas_org_type.service}`
            ];
            return !(arr.includes(this.userInfo.bizType) && `${this.dicMap.crm_transfer_order_state.finished}` === `${row.orderState}`);
          }
          return true;
        }
      }
      return false;
    },
    // 判断是否有收货权限
    checkReceiving(row) {
      if (this.userInfo) {
        return row.inOrgId === this.userInfo.rootOrgId && (this.dicMap.crm_transfer_order_state ? `${this.dicMap.crm_transfer_order_state.finished}` !== `${row.orderState}` : true);
      }
      if (this.dicMap.crm_transfer_order_state) {
        return `${this.dicMap.crm_transfer_order_state.finished}` !== `${row.orderState}`;
      }
      return false;
    },
    // 删除
    onDel(row) {
      const { orderId } = row;
      this.$showConfirm(this.$t('crm_inventory_picking_manage.nqdyscgtbdm')).then(() => {
        const url = `${apis.transferOrderDelete}/${orderId}`;
        this.$postJSON(url, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.getTableList();
        });
      });

    },
    // 撤销
    onCancel(row) {
      const workFlowType = this.workFlowType;
      const bizId = row.orderId;
      this.$showConfirm(this.$t('crm_inventory_picking_manage.nqdycxxzdddm')).then(() => {
        this.$postJSON(`${apis.apsApproveApprovalApproveRevoke}/${workFlowType}/${bizId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    // 提交
    onSubmit(row) {
      const { orderId, transferReason, orderCode } = row;
      if (!transferReason) {
        this.$message.error(this.$t('crm_inventory_picking_manage.qxtxsqyy'));
        return;
      }
      this.$showConfirm(this.$t('crm_inventory_picking_manage.nqdytjxzdddm')).then(() => {
        this.$postJSON(
          `${apis.apsApproveApprovalApproveStart}/${type}/${orderId}`,
          {
            title: [`【${orderCode}】`, this.dicMap.approval_type[this.workFlowType]].join(' '),
            applyReason: transferReason,
          },
          true
        ).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    // 作废
    onNullify(row) {
      this.$showConfirm(this.$t('crm_inventory_picking_manage.nqdyzfxzdddm')).then(() => {
        const workFlowType = this.workFlowType;
        const bizId = row.orderId;
        this.$postJSON(`${apis.apsApproveApprovalCancel}/${workFlowType}/${bizId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    getTableList() {
      this.$getJSON(apis.transferOrderPage, this.formSearch).then((res) => {
        // res.data.list.forEach((item) => {
        //   item.approvalAuth = [];
        //   const bizId = item.orderId;
        //   const bizType = 'transfer_order';
        //   this.$postJSON(apis.apsApproveGetApproveAuth, {
        //     bizId: bizId,
        //     type: bizType
        //   }).then((ret) => {
        //     item.approvalAuth = ret.data || [];
        //   });
        // });
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

    // 审批
    onApproval(row) {
      this.dialog1Model = {
        // 审批合同
        title: this.$t('crm_inventory_picking_manage.shen_pi_he_tong'),
        data: {
          ...row,
        },
        type: 'edit',
      };
      this.dialog1Visible = true;
    },
    // 修改项目负责人
    onModifyProjectLeader() {
      this.dialog2Model = {
        title: this.$t('crm_inventory_picking_manage.xgxmfzr'),
      };
      this.dialog2Visible = true;
    },
    // 服务收货
    onReceiving() {
      this.dialog3Model = {
        title: this.$t('crm_inventory_picking_manage.shgssh'),
      };
      this.dialog3Visible = true;
    },
    // 发货
    onDeliver(row) {
      this.dialog4Model = {
        title: this.$t('crm_inventory_picking_manage.fa_huo'),
        data: row,
      };
      this.dialog4Visible = true;
    },
    // 查看
    onPreview(row) {
      // this.dialog6Model = {
      //   type: 'watch',
      //   changeId: row.orderId,
      //   changeType: 'transfer_order',
      // };
      // this.dialog6Visible = true;
      this.jump('/contractInvTransDetail', {
        changeId: row.orderId,
        contractId: row.orderId,
        parentPath: '/crmStock/contractInventoryPicking'
      });
    },
    // 编辑库存调拨单
    editOrder(row) {
      this.dialog6Model = {
        type: 'edit',
        changeId: row.orderId,
        changeType: 'transfer_order',
      };
      this.dialog6Visible = true;
    },
    // 新增库存调拨单
    addOrder() {
      this.dialog6Model = {
        type: 'add',
        changeType: 'transfer_order',
      };
      this.dialog6Visible = true;
    },
    receiveGoods(row) {
      this.dialog7Model = {
        data: row,
        title: this.$t('crm_inventory_picking_manage.shgssh'),
      };
      this.dialog7Visible = true;
    },
  },
  mounted() {
    this.getDicMap('crm_transfer_order_state,bas_org_type');
    this.getDicMap('approval_type', null, { propKey: 'code', propVal: 'name' });
    this.getTableColumn();
    this.getFuncView();

    this.getTableList();
    this.Bus.$on('update', this.getTableList);
  },
};
</script>

<style lang="scss" scoped>
.contract-inventory-picking {
  padding-left: 16px;
  display: flex;
  height: 100%;
  flex-direction: column;
  .device-detail {
    width: 200px;
  }
}
</style>
